// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"style_carouselWrapper__-H0ve","wrapper":"style_wrapper__vtq-q","list":"style_list__XlJP2"};